import React from 'react';
import { Modal, Box, TextField, MenuItem, IconButton, Button } from '@material-ui/core';
// import CloseIcon from '@material-ui/icons/Close';

const modalWrapperStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  maxHeight: '90vh',
  backgroundColor: 'white',
  borderRadius: 12,
  boxShadow: 24,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

const headerStyle = {
  backgroundColor: '#75287C',
  color: 'white',
  padding: '0px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  minHeight: 56,
};

const contentStyle = {
  padding: 24,
  flex: 1,
  overflowY: 'auto',
};

const actionsStyle = {
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  borderTop: '1px solid #eee',
};

const purpleColor = 'rgb(118, 40, 124)';

const FormModalMarketConnect = ({
  open,
  onClose,
  formData,
  handleInputChange,
  handleSubmit,
  uniqueMarketOppInstanceId,
  isEdit,
  handleUpdateButtonClick,
  submitMarketConnectPersonaForm,
  marketConnectAlreadyFilledPersonaInstanceId
}) => {

  console.log(formData, ">>>>formData");

  return (
    <Modal open={open} onClose={onClose}>
      <Box style={modalWrapperStyle}>

        {/* Header */}
        <Box style={headerStyle}>
          <div>Market Connect Persona Form</div>
          <IconButton onClick={onClose} style={{ color: 'white' }}>
            {/* <CloseIcon /> */}
            X
          </IconButton>
        </Box>

        {/* Form Content */}
        <Box style={contentStyle}>
          {/* Resource Instance Id */}
          <TextField
            select
            name="nResourceInstanceId"
            label="Resource Instance Id"
            value={formData["nResourceInstanceId"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            // SelectProps={{
            //   MenuProps: {
            //     PaperProps: {
            //       style: {
            //         maxHeight: 200,
            //         width: 300,
            //       },
            //     },
            //   },
            // }}

            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    width: 300,
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null, // Very important in MUI v4
              },
            }}
            disabled={isEdit ? true : true} // resource id change nahi hone paye so disablibng for both add and edit
          >
            {uniqueMarketOppInstanceId?.map((option) => (
              <MenuItem key={option} value={option}
                disabled={marketConnectAlreadyFilledPersonaInstanceId?.includes(option)}
              >
                {option}
              </MenuItem>
            ))}
          </TextField>

          {/* Market Opportunity Type */}
          {/* <TextField
            // select
            name="Market Opportunity Type"
            label="Market Opportunity Type"
            value={formData["Market Opportunity Type"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            // disabled={true}
          >
            {['Corporate', 'Exhibition', 'E-Com', 'Bulk', 'Export'].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}

          <TextField
            name="Market Opportunity Type"
            label="Market Opportunity Type"
            value={formData["Market Opportunity Type"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="text"
            disabled={true}
          />

          {/* Market Opportunity Name */}
          {/* <TextField
            select
            name="Market Opportunity Name"
            label="Market Opportunity Name"
            value={formData["Market Opportunity Name"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          // disabled={true}
          >
            {[
              'Pune_PTK', 'Pune_PTH', 'Pune_Infrabeat', 'Pune_AMTP', 'Pune_ASTP',
              'Pune_MAGILE', 'Pune_Emmersons', 'Pune_Icertis', 'NG_PT', 'Pune_AP 81',
              'Pune_Marrisoft', 'Pune_Summercourt', 'Pune_ATC'
            ].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}

          <TextField
            name="Market Opportunity Name"
            label="Market Opportunity Name"
            value={!formData["nResourceInstanceId"] ? "" : (formData["Market Opportunity Name"] ? formData["Market Opportunity Name"] : "No opp name")}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="text"
            disabled={true}
          />

          {/* Revenue from Opportunity */}
          <TextField
            name="Revenue from Opportunity"
            label="Revenue from Opportunity"
            value={formData["Revenue from Opportunity"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="number"
          />

          {/* Market Channel Cost */}
          <TextField
            name="Market channel cost"
            label="Market Channel Cost"
            value={formData["Market channel cost"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="number"
          />

          {/* Discount Amount (Paid by deAsra) */}
          <TextField
            name="Discount Amount (Paid by deAsra)"
            label="Discount Amount (Paid by deAsra)"
            value={formData["Discount Amount (Paid by deAsra)"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="number"
          />

          {/* Stall Rent Paid by Entrepreneur */}
          <TextField
            name="Stall rent paid by Entrepreneur"
            label="Stall Rent Paid by Entrepreneur"
            value={formData["Stall rent paid by Entrepreneur"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="number"
          />

          {/* Gross Profit */}
          <TextField
            name="Gross profit"
            label="Gross Profit"
            value={formData["Gross profit"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="number"
          />

          {/* Additional Cost for the Opportunity Disclosed by Entrepreneur */}
          <TextField
            name="Additional cost for the opportunity disclosed by Entrepreneur(SGA)"
            label="Additional cost for the opportunity disclosed by Entrepreneur(SGA)"
            value={formData["Additional cost for the opportunity disclosed by Entrepreneur(SGA)"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="number"
          />

          {/* Learnings */}
          <TextField
            name="Learnings"
            label="Learnings"
            value={formData["Learnings"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="text"
          />

          {/* Challenges */}
          <TextField
            name="Challenges"
            label="Challenges"
            value={formData["Challenges"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            type="text"
          />
        </Box>


        {/* Action Buttons */}
        <Box style={actionsStyle}>
          <Button variant="outlined" onClick={onClose} style={{ color: purpleColor, borderColor: purpleColor }}>
            Cancel
          </Button>
          {
            isEdit ? (
              <Button variant="contained" onClick={() => handleUpdateButtonClick(formData)} style={{ backgroundColor: purpleColor, color: 'white' }}>
                Update
              </Button>
            ) : (
              <Button variant="contained" onClick={() => submitMarketConnectPersonaForm(formData)} style={{ backgroundColor: purpleColor, color: 'white' }}>
                Submit
              </Button>
            )
          }
        </Box>

      </Box>
    </Modal>
  );
};

export default FormModalMarketConnect;
